import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import { PALLET_NUMBER } from "../../../calculator/Calculator";
import PreviewTotalByHSCodeView from "./PreviewTotalByHSCodeView";
import ShipmentContext from "../ShipmentContext";
import ChooseOdooObjectsView from "../../odoo/ChooseOdooObjectView";
import ConfirmOdooObjectView from "../../odoo/ConfirmOdooObjectView";
import ShipmentInvoice from "./ShipmentInvoice";

function ShipmentInvoices({ children }) {
  const { state, dispatch } = useContext(ShipmentContext);
  const modal = useModals();
  const chooseOdooObjectModal = useModals();
  const confirmOdooObjectModal = useModals();

  var totalPallets = 0;
  state.shipmentInvoices.forEach((shipmentInvoice) => {
    shipmentInvoice.shipmentInvoiceRows.forEach((shipmentInvoiceRow) => {
      totalPallets += Math.ceil(shipmentInvoiceRow.totalCbm / PALLET_NUMBER);
    });
  });

  function previewTotalByHSCode() {
    modal.present({
      title: "Total by HS Code",
      maxWidth: "max-w-6xl",
      children: <PreviewTotalByHSCodeView shipment={state} />,
    });
  }

  function showOdooInvoiceSelectorView() {
    chooseOdooObjectModal.present({
      title: "Sales Order or Transfer",
      subtitle: state.customer.name,
      children: (
        <ChooseOdooObjectsView
          odooPartnerId={state.customer.odooPartnerId}
          onSelect={didChooseOdooObject}
        />
      ),
    });
  }

  function didChooseOdooObject(item) {
    confirmOdooObjectModal.present({
      title: item.name,
      subtitle: "Choose product and qty to create shipment invoice",
      maxWidth: "max-w-5xl",
      children: (
        <ConfirmOdooObjectView
          item={item}
          type="CREATE_SHIPMENT_INVOICE"
          shipmentId={state.id}
          complete={didCreateShipmentInvoice}
        />
      ),
    });
  }

  function didCreateShipmentInvoice(payload) {
    Alert("success", "Shipment Invoice created");
    dispatch({
      type: "createShipmentInvoiceFromOdoo",
      payload,
    });
    confirmOdooObjectModal.hide();
    chooseOdooObjectModal.hide();
  }

  return (
    <div>
      <h2>Products</h2>

      <div className="my-4 flex items-center">
        <Button
          onClick={showOdooInvoiceSelectorView}
          className="rounded-md px-2 py-1 text-xs transition-colors hover:bg-sky-100 active:bg-sky-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 dark:hover:bg-sky-900/60 dark:active:bg-sky-800/70"
        >
          + Shipment Invoice
        </Button>
      </div>

      <div>
        {state.shipmentInvoices.map((shipmentInvoice) => (
          <ShipmentInvoice
            key={shipmentInvoice.id}
            shipmentInvoice={shipmentInvoice}
          />
        ))}

        {state.shipmentInvoices.length > 0 && (
          <div className="mt-6 rounded-lg bg-white dark:bg-gray-800">
            <div className="flex flex-wrap items-baseline gap-x-8 gap-y-3 p-8">
              <h3 className="mr-2">Total</h3>
              <div className="flex items-baseline gap-2">
                <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                  Qty
                </span>
                <span className="text-base font-semibold tabular-nums">
                  {state.totalQty}
                </span>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                  CTN
                </span>
                <span className="text-base font-semibold tabular-nums">
                  {state.totalCarton}
                </span>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                  Pallets
                </span>
                <span className="text-base font-semibold tabular-nums">
                  {totalPallets}
                </span>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                  N.W.
                </span>
                <span className="text-base font-semibold tabular-nums">
                  {parseFloat(state.totalNetWeight).toFixed(2)}
                </span>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                  G.W.
                </span>
                <span className="text-base font-semibold tabular-nums">
                  {parseFloat(state.totalGrossWeight).toFixed(2)}
                </span>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="text-sm font-medium text-gray-600 dark:text-gray-300">
                  CBM
                </span>
                <span className="text-base font-semibold tabular-nums">
                  {parseFloat(state.totalCbm).toFixed(3)}
                </span>
              </div>
              <Button
                onClick={previewTotalByHSCode}
                className="ml-2 rounded-md px-2 py-1 text-sm transition-colors hover:bg-sky-100 active:bg-sky-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 dark:hover:bg-sky-900/60 dark:active:bg-sky-800/70"
              >
                Preview Total by HS Code
              </Button>
            </div>
            {children && (
              <>
                <div className="mx-8 border-t border-dashed border-gray-200 dark:border-gray-700" />
                <div className="p-8">{children}</div>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ShipmentInvoices;
